import { render } from "./StaffPage_Excel.vue?vue&type=template&id=4fc6dca1&scoped=true"
import script from "./StaffPage_Excel.vue?vue&type=script&lang=js"
export * from "./StaffPage_Excel.vue?vue&type=script&lang=js"

import "./StaffPage_Excel.vue?vue&type=style&index=0&id=4fc6dca1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc6dca1"]])

export default __exports__